export enum BlockModalType {
  Block = 'block',
  ReportAndBlock = 'reportAndBlock',
  ReportAsSpam = 'reportAsSpam',
}
